/* LM: swipebare productfoto's in het collectie-overzicht (Claude, 13 okt) */
(function () {
  if (window.__lmSwipe) return;
  window.__lmSwipe = true;
  var MAX = 6;
  var path = location.pathname.replace(/\/$/, '');
  var m = path.match(/^(\/[a-z]{2}(-[a-z]{2})?)?\/collections\/[^\/]+/i);
  if (!m) return;
  var base = m[0];
  var imgs = {};

  function sized(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    return String(s || '').replace(/"/g, '&quot;');
  }

  function build(card) {
    if (card.__lm) return;
    var a = card.querySelector('a[href*="/products/"]');
    var media = card.querySelector('.card__inner .card__media .media');
    if (!a || !media) return;
    var h = (a.getAttribute('href').split('/products/')[1] || '').split(/[?#\/]/)[0];
    var list = imgs[h];
    if (!list || list.length < 2) return;
    card.__lm = true;
    list = list.slice(0, MAX);
    var url = a.getAttribute('href');
    var title = (a.textContent || '').trim();
    var html = '<div class="lm-swipe__track">';
    list.forEach(function (im, i) {
      html +=
        '<a href="' + url + '" class="lm-swipe__slide" tabindex="-1" aria-label="' + esc(title) + '">' +
        '<img src="' + sized(im.src, 600) + '" srcset="' + sized(im.src, 360) + ' 360w, ' + sized(im.src, 600) + ' 600w, ' + sized(im.src, 900) + ' 900w"' +
        ' sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(im.alt || title) + '"' +
        (i ? ' loading="lazy"' : '') + ' draggable="false"></a>';
    });
    html += '</div>' +
      '<button type="button" class="lm-swipe__btn lm-swipe__btn--prev" data-lm-dir="-1" aria-label="Vorige foto">&#8249;</button>' +
      '<button type="button" class="lm-swipe__btn lm-swipe__btn--next" data-lm-dir="1" aria-label="Volgende foto">&#8250;</button>' +
      '<div class="lm-swipe__bar" aria-hidden="true"><span></span></div>';
    var wrap = document.createElement('div');
    wrap.className = 'lm-swipe';
    wrap.style.setProperty('--lm-count', list.length);
    wrap.innerHTML = html;
    media.classList.remove('media--hover-effect');
    media.innerHTML = '';
    media.appendChild(wrap);
    card.classList.add('lm-has-swipe');
  }

  function scan() {
    document.querySelectorAll('.card-wrapper').forEach(build);
  }

  function update(track) {
    var root = track.closest('.lm-swipe');
    if (!root) return;
    var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
    var bar = root.querySelector('.lm-swipe__bar span');
    if (bar) bar.style.transform = 'translateX(' + i * 100 + '%)';
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('lm-swipe__track')) update(t);
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.lm-swipe__btn');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var track = b.closest('.lm-swipe').querySelector('.lm-swipe__track');
    var dir = parseInt(b.getAttribute('data-lm-dir'), 10);
    var max = track.scrollWidth - track.clientWidth;
    var next = track.scrollLeft + dir * track.clientWidth;
    if (next > max + 2) next = 0;
    else if (next < -2) next = max;
    track.scrollTo({ left: next, behavior: 'smooth' });
  }, true);

  function load(page) {
    return fetch(base + '/products.json?limit=250&page=' + page)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = d.products || [];
        ps.forEach(function (p) {
          imgs[p.handle] = (p.images || []).map(function (im) { return { src: im.src, alt: im.alt }; });
        });
        if (ps.length === 250 && page < 4) return load(page + 1);
      });
  }

  function start() {
    load(1).then(function () {
      scan();
      new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
